// The one way the payroll UI shows a value the server withheld because the viewer may not
// see it. Shared so "restricted" reads the same everywhere and is never confused with a
// zero, a dash or "not set".
import React from 'react';
import { Lock } from 'lucide-react';
import { cn } from '@/lib/utils';
import { RESTRICTED_PAY_MESSAGE, RESTRICTED_SHORT } from '../lib/compensationAccess';

/** Inline "Restricted" for a table cell or stat value. */
export const RestrictedValue: React.FC<{ className?: string; title?: string }> = ({ className, title }) => (
  <span
    className={cn('inline-flex items-center gap-1 text-muted-foreground', className)}
    title={title ?? "You don't have access to these pay figures"}
  >
    <Lock className="h-3.5 w-3.5" aria-hidden />
    {RESTRICTED_SHORT}
  </span>
);

/** The full sentence for a person's pay (profile, compensation card). */
export const RestrictedPayNotice: React.FC<{ className?: string }> = ({ className }) => (
  <p
    role="note"
    className={cn('flex items-center gap-2 rounded-md border border-border bg-card px-3 py-2 text-sm text-muted-foreground', className)}
  >
    <Lock className="h-4 w-4 shrink-0" aria-hidden />
    {RESTRICTED_PAY_MESSAGE}
  </p>
);
